module.exports = __webpack_public_path__ + "img/e7f187f.jpg";